document.addEventListener('DOMContentLoaded', function () {
  const readMoreDivs = document.querySelectorAll('.read-more');

  readMoreDivs.forEach(function (div) {
    const paragraph = div.querySelector('p');
    if (!paragraph) return;

    const fullText = paragraph.textContent.trim();
    const words = fullText.split(' ');

    const maxWords = window.innerWidth <= 767 ? 10 : 14;

    if (words.length > maxWords) {
      const visibleText = words.slice(0, maxWords).join(' ');

      const textSpan = document.createElement('span');
      textSpan.classList.add('readmore-text');
      textSpan.textContent = visibleText + '... ';

      const link = document.createElement('a');


      link.textContent = 'Click Here';

      link.href = 'https://ux20qb-r9.myshopify.com/blogs/news/now-accepting-payment-via-klarna-online';
      link.style.fontWeight = 'bold';
      link.style.cursor = 'pointer';
      link.style.color = '#ffffff';

      // Optional (extra accessibility boost)
      link.setAttribute(
        'aria-label',
        'Read the full article about Klarna payment options'
      );

      paragraph.textContent = '';
      paragraph.appendChild(textSpan);
      paragraph.appendChild(link);
    }
  });
});